const CITIES_2 = {
  'minneapolis': {
    name: 'Minneapolis', state: 'MN', population: '430K', restaurants: '2,200+',
    tagline: 'Scandinavian roots, global palate',
    foodScene: 'Minneapolis surprises with its depth. The Somali, Hmong, and Mexican communities have transformed the dining landscape. Eat Street is the culinary corridor, North Loop has chef-driven restaurants, and Midtown Global Market represents 20+ countries.',
    topCuisines: [
      { emoji: '🥘', name: 'Somali', note: 'Largest Somali community in the US' },
      { emoji: '🍜', name: 'Hmong/SE Asian', note: 'St. Paul\'s Hmong Village' },
      { emoji: '🌮', name: 'Mexican', note: 'Lake Street taco trail' },
      { emoji: '🧇', name: 'Brunch', note: 'Year-round obsession' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Surly, Indeed, Fulton' },
      { emoji: '🥧', name: 'Scandinavian', note: 'Lefse, Nordic comfort' }
    ],
    neighborhoods: ['North Loop', 'Eat Street', 'Northeast', 'Uptown', 'Midtown Global Market', 'Linden Hills'],
    knownFor: 'Somali food, Midtown Global Market, Eat Street, Juicy Lucy burger, Scandinavian heritage',
    nearby: ['milwaukee', 'chicago', 'omaha']
  },
  'charlotte': {
    name: 'Charlotte', state: 'NC', population: '880K', restaurants: '3,000+',
    tagline: 'New South dining hub',
    foodScene: 'Charlotte has rapidly grown into one of the South\'s most exciting food cities. South End and NoDa are packed with restaurants and breweries. Central Avenue has become an international food corridor with Vietnamese, Mexican, Salvadoran, and Indian restaurants.',
    topCuisines: [
      { emoji: '🍗', name: 'Southern Comfort', note: 'Fried chicken, shrimp & grits' },
      { emoji: '🍖', name: 'Carolina BBQ', note: 'Vinegar-based Eastern NC style' },
      { emoji: '🌮', name: 'International', note: 'Central Avenue food corridor' },
      { emoji: '🍺', name: 'Craft Beer', note: 'OMB, NoDa Brewing, Birdsong' },
      { emoji: '🍳', name: 'Brunch', note: 'South End weekend ritual' },
      { emoji: '🥘', name: 'Indian', note: 'Growing scene on South Blvd' }
    ],
    neighborhoods: ['South End', 'NoDa', 'Plaza Midwood', 'Dilworth', 'Central Avenue', 'Uptown'],
    knownFor: 'Carolina BBQ, Central Avenue international food, South End food halls, craft breweries',
    nearby: ['raleigh', 'atlanta', 'richmond']
  },
  'raleigh': {
    name: 'Raleigh', state: 'NC', population: '470K', restaurants: '1,800+',
    tagline: 'Triangle food, research park creativity',
    foodScene: 'The Research Triangle brings a young, adventurous eating population. Traditional NC BBQ meets inventive Southern tasting menus. Downtown Raleigh\'s warehouse district is a dining destination, while Durham and Chapel Hill add variety.',
    topCuisines: [
      { emoji: '🍖', name: 'NC BBQ', note: 'Eastern-style whole hog' },
      { emoji: '🍗', name: 'Southern', note: 'Biscuits, fried chicken, collards' },
      { emoji: '🌮', name: 'Mexican', note: 'Growing taqueria scene' },
      { emoji: '🍳', name: 'Brunch', note: 'Triangle weekend tradition' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Trophy, Ponysaurus, Burial' },
      { emoji: '🍽️', name: 'New Southern', note: 'Chef-driven farm-to-fork' }
    ],
    neighborhoods: ['Downtown Warehouse District', 'Glenwood South', 'North Hills', 'Durham', 'Chapel Hill', 'Cary'],
    knownFor: 'Eastern NC BBQ, Research Triangle innovation, biscuit culture, Glenwood South',
    nearby: ['charlotte', 'richmond', 'washington-dc']
  },
  'orlando': {
    name: 'Orlando', state: 'FL', population: '310K', restaurants: '3,500+',
    tagline: 'Beyond the theme parks',
    foodScene: 'Orlando\'s food extends far beyond theme parks. Mills 50 is a Vietnamese food mecca, Winter Park has upscale Park Avenue dining, and the tourism economy means restaurants compete hard — better food at every price point.',
    topCuisines: [
      { emoji: '🍜', name: 'Vietnamese', note: 'Mills 50 district is legendary' },
      { emoji: '🌮', name: 'Latin American', note: 'Puerto Rican, Colombian, Brazilian' },
      { emoji: '🍖', name: 'BBQ', note: 'Florida-style smoked meats' },
      { emoji: '🐊', name: 'Southern & Cajun', note: 'Gator bites & po\' boys' },
      { emoji: '🍣', name: 'Japanese', note: 'International Drive corridor' },
      { emoji: '🍕', name: 'Pizza', note: 'NY transplant pizzerias' }
    ],
    neighborhoods: ['Mills 50', 'Winter Park', 'Milk District', 'Thornton Park', 'Audubon Park', 'I-Drive'],
    knownFor: 'Mills 50 Vietnamese food, theme park dining, Winter Park fine dining, Latin food',
    nearby: ['tampa', 'miami', 'jacksonville']
  },
  'tampa': {
    name: 'Tampa', state: 'FL', population: '400K', restaurants: '2,800+',
    tagline: 'Cuban sandwiches and Gulf Coast catches',
    foodScene: 'Tampa\'s food identity starts with the Cuban sandwich — invented here in Ybor City by Cuban, Italian, and Spanish cigar workers. Seminole Heights is the hip food neighborhood, and Gulf Coast location means fresh grouper, stone crab, and shrimp on every menu.',
    topCuisines: [
      { emoji: '🥪', name: 'Cuban Sandwiches', note: 'Invented here in Ybor City' },
      { emoji: '🦐', name: 'Gulf Seafood', note: 'Grouper, stone crab, shrimp' },
      { emoji: '🇨🇺', name: 'Cuban/Spanish', note: 'Columbia Restaurant legacy' },
      { emoji: '🍗', name: 'Southern', note: 'Comfort food with Florida flair' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Cigar City Brewing & more' },
      { emoji: '🌮', name: 'Mexican', note: 'Growing taqueria scene' }
    ],
    neighborhoods: ['Ybor City', 'Seminole Heights', 'Hyde Park', 'SoHo', 'Channelside', 'South Tampa'],
    knownFor: 'Cuban sandwich capital, Ybor City, Gulf seafood, Columbia Restaurant, Cigar City Brewing',
    nearby: ['orlando', 'miami', 'jacksonville']
  },
  'new-orleans': {
    name: 'New Orleans', state: 'LA', population: '390K', restaurants: '2,500+',
    tagline: 'America\'s most delicious city',
    foodScene: 'New Orleans doesn\'t just have a food scene — food IS the scene. Creole and Cajun form the backbone: gumbo, jambalaya, crawfish. The French Quarter has iconic 100-year-old restaurants while Freret and Magazine Streets showcase evolution.',
    topCuisines: [
      { emoji: '🦞', name: 'Cajun/Creole', note: 'Gumbo, jambalaya, crawfish boils' },
      { emoji: '🥖', name: 'Po\' Boys', note: 'Shrimp, oyster, roast beef' },
      { emoji: '🦪', name: 'Oysters', note: 'Chargrilled or raw half shell' },
      { emoji: '🍩', name: 'Beignets', note: 'Café du Monde at 2am' },
      { emoji: '🍛', name: 'Red Beans & Rice', note: 'Monday tradition citywide' },
      { emoji: '🍸', name: 'Cocktail Culture', note: 'Sazerac, Hurricane, French 75' }
    ],
    neighborhoods: ['French Quarter', 'Magazine Street', 'Freret Street', 'Bywater', 'Garden District', 'Tremé'],
    knownFor: 'Gumbo, beignets, po\' boys, chargrilled oysters, Cajun/Creole, cocktail birthplace',
    nearby: ['houston', 'memphis', 'birmingham']
  },
  'pittsburgh': {
    name: 'Pittsburgh', state: 'PA', population: '305K', restaurants: '1,800+',
    tagline: 'Steel City, iron stomach',
    foodScene: 'Pittsburgh\'s food has reinvented itself. The Strip District is the food corridor — European delis, Asian markets, specialty shops. Lawrenceville is nationally recognized. Polish, Italian, and Eastern European influences run deep.',
    topCuisines: [
      { emoji: '🥪', name: 'Primanti Bros', note: 'Fries & slaw on the sandwich' },
      { emoji: '🥟', name: 'Pierogi', note: 'Polish heritage comfort food' },
      { emoji: '🍝', name: 'Italian', note: 'Bloomfield — Little Italy' },
      { emoji: '🍖', name: 'BBQ & Sandwiches', note: 'Hearty, blue-collar portions' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Church Brew Works & more' },
      { emoji: '🥗', name: 'Modern American', note: 'Lawrenceville chef spots' }
    ],
    neighborhoods: ['Strip District', 'Lawrenceville', 'Bloomfield', 'South Side', 'Shadyside', 'Mt. Washington'],
    knownFor: 'Primanti Brothers, pierogi, Strip District, Lawrenceville dining, steel-city comfort',
    nearby: ['cleveland', 'philadelphia', 'columbus']
  },
  'sacramento': {
    name: 'Sacramento', state: 'CA', population: '525K', restaurants: '2,200+',
    tagline: 'America\'s farm-to-fork capital',
    foodScene: 'Sacramento declared itself America\'s Farm-to-Fork Capital, and the food backs it up. Surrounded by Central Valley farmland, restaurants get ingredients harvested that morning. Midtown is a serious dining corridor with diverse Hmong, Vietnamese, and Mexican food.',
    topCuisines: [
      { emoji: '🥗', name: 'Farm-to-Fork', note: 'Official capital of the movement' },
      { emoji: '🌮', name: 'Mexican', note: 'South Sac authenticity' },
      { emoji: '🍜', name: 'Hmong/Vietnamese', note: 'Stockton Blvd corridor' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Midtown brewery trail' },
      { emoji: '🍳', name: 'Brunch', note: 'Weekend sidewalk dining' },
      { emoji: '🍝', name: 'Italian', note: 'Historic Gold Rush heritage' }
    ],
    neighborhoods: ['Midtown', 'Downtown', 'Oak Park', 'East Sacramento', 'Natomas', 'Old Sacramento'],
    knownFor: 'Farm-to-fork capital, Central Valley freshness, Midtown dining, Hmong food',
    nearby: ['san-francisco', 'san-jose', 'los-angeles']
  },
  'salt-lake-city': {
    name: 'Salt Lake City', state: 'UT', population: '200K', restaurants: '1,500+',
    tagline: 'Mountain town food with surprising depth',
    foodScene: 'SLC consistently surprises visitors. An international food corridor on State Street, excellent Polynesian restaurants (Utah\'s large Pacific Islander community), and a craft brewery scene that defies stereotypes. Proximity to ski resorts adds après-ski dining.',
    topCuisines: [
      { emoji: '🍖', name: 'BBQ & Western', note: 'Utah-style beef & fry sauce' },
      { emoji: '🌺', name: 'Polynesian', note: 'Large Pacific Islander community' },
      { emoji: '🌮', name: 'Mexican', note: 'West Valley taquerias' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Defying stereotypes' },
      { emoji: '🍔', name: 'Burgers', note: 'Fry sauce is a Utah invention' },
      { emoji: '🥗', name: 'Health-Conscious', note: 'Active lifestyle meets food' }
    ],
    neighborhoods: ['9th & 9th', 'Sugar House', 'Downtown', 'The Avenues', 'Liberty Park', 'Cottonwood Heights'],
    knownFor: 'Fry sauce, Polynesian food, ski-town dining, craft breweries, State Street corridor',
    nearby: ['denver', 'boise', 'las-vegas']
  },
  'san-jose': {
    name: 'San Jose', state: 'CA', population: '1M', restaurants: '3,200+',
    tagline: 'Silicon Valley\'s melting pot kitchen',
    foodScene: 'San Jose is the heart of Silicon Valley, and its food reflects the tech industry\'s global workforce. Vietnamese food is exceptional, Japantown is historic, and Eastside has incredible Mexican restaurants. Santana Row adds upscale dining.',
    topCuisines: [
      { emoji: '🍜', name: 'Vietnamese', note: 'One of America\'s best scenes' },
      { emoji: '🍣', name: 'Japanese', note: 'Historic Japantown' },
      { emoji: '🌮', name: 'Mexican', note: 'Eastside & Story Road' },
      { emoji: '🍛', name: 'Indian', note: 'Sunnyvale & Milpitas corridor' },
      { emoji: '🥡', name: 'Chinese', note: 'Cupertino strip malls' },
      { emoji: '🍽️', name: 'Upscale', note: 'Santana Row dining' }
    ],
    neighborhoods: ['Japantown', 'Santana Row', 'Downtown', 'Willow Glen', 'Eastside', 'South First Street'],
    knownFor: 'Vietnamese food, Japantown, Silicon Valley dining, Mexican on Story Road',
    nearby: ['san-francisco', 'sacramento', 'los-angeles']
  },
  'indianapolis': {
    name: 'Indianapolis', state: 'IN', population: '890K', restaurants: '2,400+',
    tagline: 'Heartland hospitality, racing city flavor',
    foodScene: 'Indianapolis has quietly built one of the Midwest\'s most diverse food scenes. Mass Ave is the dining corridor, Fountain Square has creative restaurants, and the International Marketplace is a genuine United Nations of food.',
    topCuisines: [
      { emoji: '🥩', name: 'Pork Tenderloin', note: 'Indiana\'s state sandwich' },
      { emoji: '🍖', name: 'BBQ', note: 'Hoosier-style smoked meats' },
      { emoji: '🌍', name: 'International', note: 'International Marketplace district' },
      { emoji: '🍳', name: 'Brunch', note: 'Mass Ave weekend lines' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Sun King, Metazoa, Taxman' },
      { emoji: '🍗', name: 'Comfort Food', note: 'Heartland portions' }
    ],
    neighborhoods: ['Mass Ave', 'Fountain Square', 'Broad Ripple', 'International Marketplace', 'Irvington', 'Fletcher Place'],
    knownFor: 'Pork tenderloin sandwich, International Marketplace, Mass Ave dining, Indy 500',
    nearby: ['chicago', 'columbus', 'louisville']
  },
  'columbus': {
    name: 'Columbus', state: 'OH', population: '905K', restaurants: '2,600+',
    tagline: 'The Midwest\'s best-kept food secret',
    foodScene: 'Columbus is a test market for restaurant chains, meaning adventurous palates. The real magic is independent — Short North has innovative restaurants, German Village preserves heritage, and Somali restaurants on Morse Road are exceptional.',
    topCuisines: [
      { emoji: '🌭', name: 'Ohio Comfort', note: 'Thurman Burger & Schmidt\'s' },
      { emoji: '🥘', name: 'Somali', note: 'Morse Road corridor' },
      { emoji: '🍺', name: 'German Heritage', note: 'German Village beer halls' },
      { emoji: '🌮', name: 'Mexican', note: 'Sullivant Ave taquerias' },
      { emoji: '🍳', name: 'Brunch', note: 'Short North weekend ritual' },
      { emoji: '🍽️', name: 'Test Market', note: 'Chains test here first' }
    ],
    neighborhoods: ['Short North', 'German Village', 'Italian Village', 'Clintonville', 'Grandview', 'Victorian Village'],
    knownFor: 'Short North dining, German Village, Thurman Burger, Somali food, test market',
    nearby: ['cleveland', 'cincinnati', 'pittsburgh']
  },
  'kansas-city': {
    name: 'Kansas City', state: 'MO', population: '510K', restaurants: '2,100+',
    tagline: 'BBQ capital of the world',
    foodScene: 'Kansas City takes BBQ more seriously than anywhere on Earth with 100+ joints. The style — slow-smoked with thick, sweet tomato sauce — is distinctly KC. Crossroads Arts District has become a dining destination beyond BBQ.',
    topCuisines: [
      { emoji: '🍖', name: 'KC BBQ', note: 'Joe\'s, Q39, Gates, Bryant\'s' },
      { emoji: '🥩', name: 'Steakhouses', note: 'Stockyard heritage beef' },
      { emoji: '🌮', name: 'Mexican', note: 'Southwest Blvd taco trail' },
      { emoji: '🍜', name: 'Vietnamese', note: 'Columbus Park community' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Boulevard Brewing & locals' },
      { emoji: '🧈', name: 'Comfort Food', note: 'Burnt ends & cheesy corn' }
    ],
    neighborhoods: ['Crossroads', 'River Market', 'Westport', 'Country Club Plaza', 'Southwest Blvd', '39th Street'],
    knownFor: 'BBQ capital, burnt ends, thick sweet sauce, Crossroads, Boulevard Brewing',
    nearby: ['st-louis', 'omaha', 'denver']
  },
  'st-louis': {
    name: 'St. Louis', state: 'MO', population: '300K', restaurants: '2,000+',
    tagline: 'Toasted ravioli and provel cheese',
    foodScene: 'St. Louis has a food identity all its own. Provel cheese, toasted ravioli (deep-fried), and cracker-thin pizza are local inventions residents defend fiercely. The Hill is Italian-American, South Grand is international, and affordability means incredible value.',
    topCuisines: [
      { emoji: '🍕', name: 'STL Pizza', note: 'Cracker crust, Provel, square-cut' },
      { emoji: '🥟', name: 'Toasted Ravioli', note: 'Deep-fried invention' },
      { emoji: '🍝', name: 'Italian', note: 'The Hill neighborhood' },
      { emoji: '🍖', name: 'BBQ', note: 'Pappy\'s & Bogart\'s' },
      { emoji: '🌍', name: 'International', note: 'South Grand corridor' },
      { emoji: '🍺', name: 'Beer', note: 'Anheuser-Busch hometown' }
    ],
    neighborhoods: ['The Hill', 'South Grand', 'Central West End', 'Soulard', 'The Grove', 'Cherokee Street'],
    knownFor: 'Provel cheese, toasted ravioli, STL pizza, The Hill, Budweiser hometown',
    nearby: ['kansas-city', 'chicago', 'indianapolis']
  },
  'milwaukee': {
    name: 'Milwaukee', state: 'WI', population: '575K', restaurants: '1,800+',
    tagline: 'Beer, brats, and a chef-driven revival',
    foodScene: 'Milwaukee\'s DNA is German — beer halls, bratwurst, and cheese curds. But Third Ward and Bay View have sparked a culinary revival. The Friday fish fry is citywide tradition and the frozen custard rivalry is taken very seriously.',
    topCuisines: [
      { emoji: '🌭', name: 'Bratwurst', note: 'Stadium-style & beer garden' },
      { emoji: '🧀', name: 'Cheese Curds', note: 'Deep-fried Wisconsin pride' },
      { emoji: '🐟', name: 'Friday Fish Fry', note: 'City-wide weekly tradition' },
      { emoji: '🍺', name: 'Beer Halls', note: 'Brewing capital heritage' },
      { emoji: '🍦', name: 'Frozen Custard', note: 'Kopp\'s vs Leon\'s' },
      { emoji: '🍽️', name: 'Modern Wisconsin', note: 'Third Ward chef spots' }
    ],
    neighborhoods: ['Third Ward', 'Bay View', 'Brady Street', 'Walker\'s Point', 'East Side', 'Wauwatosa'],
    knownFor: 'Friday fish fry, cheese curds, bratwurst, frozen custard, beer capital',
    nearby: ['chicago', 'minneapolis', 'detroit']
  },
  'baltimore': {
    name: 'Baltimore', state: 'MD', population: '585K', restaurants: '2,000+',
    tagline: 'Crab cakes and Charm City character',
    foodScene: 'Baltimore is crab cake country. Old Bay goes on everything. The Inner Harbor and Fells Point have waterfront dining, Hampden has quirky independents, and the city\'s affordability means chefs take creative risks they can\'t in DC.',
    topCuisines: [
      { emoji: '🦀', name: 'Crab Cakes', note: 'Old Bay-seasoned Maryland blue' },
      { emoji: '🥩', name: 'Pit Beef', note: 'Charcoal-grilled, sliced thin' },
      { emoji: '🦪', name: 'Oysters', note: 'Chesapeake Bay fresh' },
      { emoji: '🍗', name: 'Soul Food', note: 'West Baltimore traditions' },
      { emoji: '🍝', name: 'Italian', note: 'Little Italy neighborhood' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Union, Heavy Seas, RAR' }
    ],
    neighborhoods: ['Fells Point', 'Hampden', 'Federal Hill', 'Canton', 'Inner Harbor', 'Little Italy'],
    knownFor: 'Crab cakes, Old Bay everything, pit beef, Lexington Market, Chesapeake seafood',
    nearby: ['washington-dc', 'philadelphia', 'richmond']
  },
  'washington-dc': {
    name: 'Washington', state: 'DC', population: '690K', restaurants: '4,000+',
    tagline: 'Power lunches and global diplomacy on a plate',
    foodScene: 'DC has evolved far beyond steakhouse power lunches. Ethiopian on U Street (best outside Addis Ababa), Salvadoran in Mount Pleasant, Vietnamese in Falls Church. José Andrés built his empire here. Ben\'s Chili Bowl remains an institution.',
    topCuisines: [
      { emoji: '🇪🇹', name: 'Ethiopian', note: 'U Street — best outside Africa' },
      { emoji: '🌭', name: 'Half-Smokes', note: 'Ben\'s Chili Bowl institution' },
      { emoji: '🌮', name: 'Salvadoran', note: 'Mount Pleasant pupusas' },
      { emoji: '🍽️', name: 'Fine Dining', note: 'José Andrés & Michelin stars' },
      { emoji: '🍜', name: 'Vietnamese', note: 'Falls Church & Eden Center' },
      { emoji: '🥗', name: 'International', note: 'Embassy-driven global cuisine' }
    ],
    neighborhoods: ['14th Street', 'Shaw', 'Georgetown', 'Dupont Circle', 'Adams Morgan', 'U Street'],
    knownFor: 'Ethiopian corridor, Ben\'s Chili Bowl, José Andrés, embassy-driven global cuisine',
    nearby: ['baltimore', 'philadelphia', 'richmond']
  },
  'honolulu': {
    name: 'Honolulu', state: 'HI', population: '350K', restaurants: '2,500+',
    tagline: 'Where the Pacific Rim meets your plate',
    foodScene: 'Honolulu\'s food is unlike anywhere else in America. Plate lunches, poke bowls (the original), and multicultural heritage blending Hawaiian, Japanese, Filipino, Chinese, Korean, and Portuguese flavors into something unique.',
    topCuisines: [
      { emoji: '🐟', name: 'Poke', note: 'The original, not mainland version' },
      { emoji: '🍚', name: 'Plate Lunch', note: '2 scoops rice + mac salad' },
      { emoji: '🍣', name: 'Japanese', note: 'Ramen, sushi, izakaya' },
      { emoji: '🥘', name: 'Filipino', note: 'Adobo, pancit, lumpia' },
      { emoji: '🍩', name: 'Malasadas', note: 'Portuguese doughnuts' },
      { emoji: '🌺', name: 'Hawaiian', note: 'Kalua pork, poi, haupia' }
    ],
    neighborhoods: ['Waikiki', 'Kaimuki', 'Chinatown', 'Kailua', 'Ala Moana', 'Kapahulu'],
    knownFor: 'Poke bowls, plate lunch, Spam musubi, shave ice, malasadas, loco moco',
    nearby: []
  },
  'memphis': {
    name: 'Memphis', state: 'TN', population: '630K', restaurants: '1,600+',
    tagline: 'Blues, Beale Street, and the best ribs on Earth',
    foodScene: 'Memphis is a BBQ pilgrimage site. Dry-rubbed ribs are the crown jewel — no sauce needed. Beale Street has tourists, but the real food is on neighborhood corners: hole-in-the-wall BBQ joints, soul food cafeterias, and tamale shops.',
    topCuisines: [
      { emoji: '🍖', name: 'Memphis BBQ', note: 'Dry-rub ribs, pulled pork' },
      { emoji: '🍗', name: 'Soul Food', note: 'Fried catfish, greens, cornbread' },
      { emoji: '🫔', name: 'Tamales', note: 'Delta hot tamale tradition' },
      { emoji: '🍕', name: 'BBQ Pizza', note: 'Only-in-Memphis creation' },
      { emoji: '🍝', name: 'BBQ Spaghetti', note: 'Yes, really. It\'s great.' },
      { emoji: '🎵', name: 'Beale Street Eats', note: 'Blues clubs + food' }
    ],
    neighborhoods: ['Beale Street', 'Cooper-Young', 'Overton Square', 'South Main', 'Midtown', 'Crosstown'],
    knownFor: 'Dry-rub ribs, BBQ capital, Beale Street, Delta tamales, Gus\'s Fried Chicken',
    nearby: ['nashville', 'new-orleans', 'birmingham']
  }
};

export default CITIES_2;
